import { StateStorage } from 'zustand/middleware';
import setUrlParams from './setUrlParams';
import getUrlParams from './getUrlParams';

const getStoredValue = (key: string): string => {
  try {
    return localStorage?.getItem(key) || '{}';
  } catch {
    return '{}';
  }
};

const setStoredValue = (key: string, value: string): void => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(key, value);
  }
};

const normalizeState = (data: any) => ({
  ...data,
  state: {
    ...data?.state,
    favorites: data?.state?.favorites || {},
    disabledNotificationTitle: data?.state?.disabledNotificationTitle || [],
    drawFeatures: data?.state?.drawFeatures || [],
  },
});

const persistentStorage: StateStorage = {
  getItem: async (key) => {
    const parsedLocalData = normalizeState(JSON.parse(getStoredValue(key)));

    const urlstate = await getUrlParams();
    if (urlstate) {
      parsedLocalData.state = {
        favorites: { ...parsedLocalData.state.favorites },
        disabledNotificationTitle: [...parsedLocalData.state.disabledNotificationTitle],
        drawFeatures: [...parsedLocalData.state.drawFeatures],
        accordions: { ...parsedLocalData.state.accordions },
        tolerance: parsedLocalData.state.tolerance,
        ...urlstate,
      };
    }

    return JSON.stringify(parsedLocalData);
  },
  setItem: (key, newValue): void => {
    setUrlParams(getStoredValue(key), newValue);
    setStoredValue(key, newValue);
  },
  removeItem: (key): void => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(key);
    window.location.search = searchParams.toString();
  },
};

export default persistentStorage;
